const isSessionStorageEnabled = () => {
    try {
        sessionStorage.setItem('test-session-storage', 'test-session-storage');
        sessionStorage.removeItem('test-session-storage');
        return true;
    } catch (err) {
        return false;
    }
};

export const setSessionStorageItem = (key, value) => {
    if (isSessionStorageEnabled()) {
        sessionStorage.setItem(key, value);
    }
};



// WEBPACK FOOTER //
// ./src/js/utils/sessionStorage.js